import React, { useState, useEffect } from 'react';
import { Row, Col, Input, Tag, Checkbox, Button, Card } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { remove } from 'lodash';
import { API } from 'aws-amplify';
import FiltersTable from '../../FiltersTable';
import '../../../../styles/Demograficos.css';
import {usePagination} from '../../../../hooks/useFiltersPagination.js';

const { Search } = Input;

const Demograficos = ({
  genero,
  setGenero,
  planCost,
  setPlanCost,
  edad,
  setEdad,
}) => {
  const [selectedData1, setSelectedData1] = useState([]);
  const [selectedData2, setSelectedData2] = useState([]);
  const [selectedData3, setSelectedData3] = useState([]);
  const [searchValue1, setSearchValue1] = useState('');
  const [searchValue2, setSearchValue2] = useState('');
  const [searchValue3, setSearchValue3] = useState('');
  const [showLoadingData1, setShowLoadingData1] = useState(false);
  const [showLoadingData2, setShowLoadingData2] = useState(false);
  const [showLoadingData3, setShowLoadingData3] = useState(false);
  const [selectedsData1, setSelectedsData1] = useState([]);
  const [selectedsData2, setSelectedsData2] = useState([]);
  const [selectedsData3, setSelectedsData3] = useState([]);
  const [banderaTags1, setBanderaTags1] = useState(false);
  const [banderaTags2, setBanderaTags2] = useState(false);
  const [banderaTags3, setBanderaTags3] = useState(false);


  const fetchFilter1 = async (filter = null) => {
    try {
      const response = await API.graphql({
        query: `query MyQuery {
          getFiltersRedshift(input: { query: "getGender", name_filter: "${filter}" }) {
            key
            description_filter
            type_filter
            value_filter
          }
        }`
      });

      const data = response.data.getFiltersRedshift;
      setSelectedData1(data.length > 0 && data[0].value_filter !== "Sin Datos" ? data.sort((a, b) => a.value_filter.localeCompare(b.value_filter)) : []);
      setShowLoadingData1(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    setShowLoadingData1(true);
    fetchFilter1(searchValue1);
  }, [searchValue1]);

  const fetchFilter2 = async (filter = null) => {
    try {
      const response = await API.graphql({
        query: `query MyQuery {
          getFiltersRedshift(input: { query: "getPlanCost", name_filter: "${filter}" }) {
            key
            description_filter
            type_filter
            value_filter
          }
        }`
      });

      const data = response.data.getFiltersRedshift;
      setSelectedData2(data.length > 0 && data[0].value_filter !== "Sin Datos" ? data : []);
      setShowLoadingData2(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  useEffect(() => {
    setShowLoadingData2(true);
    fetchFilter2(searchValue2);
  }, [searchValue2]);

  const fetchFilter3 = async (filter = null) => {
    try {
      const response = await API.graphql({
        query: `query MyQuery {
          getFiltersRedshift(input: { query: "getAges", name_filter: "${filter}" }) {
            key
            description_filter
            type_filter
            value_filter
          }
        }`
      });

      const data = response.data.getFiltersRedshift;
      setSelectedData3(data.length > 0 && data[0].value_filter !== "Sin Datos" ? data.sort((a, b) => a.value_filter.localeCompare(b.value_filter)) : []);
      setShowLoadingData3(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  useEffect(() => {
    setShowLoadingData3(true);
    fetchFilter3(searchValue3);
  }, [searchValue3]);

  useEffect(() => {
    setSelectedsData3(edad);
  }, [edad]);

  useEffect(() => {
    if (genero.length === 0) {
      setSelectedsData1([]);
      setBanderaTags1(false);
    }
  }, [genero]);

  
  useEffect(() => {
    if (planCost.length === 0) {
      setSelectedsData2([]);
      setBanderaTags2(false);
    }
  }, [planCost]);

  
  useEffect(() => {
    if (edad.length === 0) {
      setSelectedsData3([]);
      setBanderaTags3(false);
    }
  }, [edad]);

  const filters = [
    {
      title: 'Genero',
      selectedData: selectedData1,
      setSelectedData: setSelectedData1,
      selectedsData: selectedsData1,
      setSelectedsData: setSelectedsData1,
      filterComponent: genero,
      setFilterComponent: setGenero,
      banderaTags: banderaTags1,
      setBanderaTags: setBanderaTags1,
      showLoadingData: showLoadingData1,
      setShowLoadingData: setShowLoadingData1
    },
    {
      title: "Costo del Plan",
      selectedData: selectedData2,
      setSelectedData: setSelectedData2,
      selectedsData: selectedsData2,
      setSelectedsData: setSelectedsData2,
      filterComponent: planCost,
      setFilterComponent: setPlanCost,
      banderaTags: banderaTags2,
      setBanderaTags: setBanderaTags2,
      showLoadingData: showLoadingData2,
      setShowLoadingData: setShowLoadingData2
    },
    {
      title: 'Edad',
      selectedData: selectedData3,
      setSelectedData: setSelectedData3,
      selectedsData: selectedsData3,
      setSelectedsData: setSelectedsData3,
      filterComponent: edad,
      setFilterComponent: setEdad,
      banderaTags: banderaTags3,
      setBanderaTags: setBanderaTags3,
      showLoadingData: showLoadingData3,
      setShowLoadingData: setShowLoadingData3
    },

  ];

  const {
    currentPage,
    transitionClass,
    handleNext,
    handlePrev,
    visibleItems: visibleFilters,
    startIndex,
    endIndex,
  } = usePagination(filters);

  return ( 
    <Row className="DemograficosColumns" gutter={16}>
      <Col span={12}>
        <Row gutter={[16, 24]}>
          {visibleFilters.map((filter, index) => (
            <Col span={12} key={index} > 
              <h3>{filter.title}</h3>
              <FiltersTable
                selectedData={filter.selectedData}
                setSelectedData={filter.setSelectedData}
                selectedsData={filter.selectedsData}
                setSelectedsData={filter.setSelectedsData}
                filterComponent={filter.filterComponent}
                setFilterComponent={filter.setFilterComponent}
                banderaTags={filter.banderaTags}
                setBanderaTags={filter.setBanderaTags}
                showLoadingData={filter.showLoadingData}
                setShowLoadingData={filter.setShowLoadingData}
              />
            </Col>
          ))}
        </Row>
        {filters.length > 2 && (
          <Row style={{ marginTop: '20px', justifyContent: 'center' }}>
            <div style={{ display: 'flex', gap: '16px' }}>
              <Button
                className="navigation-button"
                shape="circle"
                icon={<LeftOutlined />}
                onClick={handlePrev}
                disabled={currentPage === 0}
              />
              <Button
                className="navigation-button"
                shape="circle"
                icon={<RightOutlined />}
                onClick={handleNext}
                disabled={endIndex >= filters.length}
              />
            </div>
          </Row>
        )}
      </Col>
      <Col span={12} style={{ justifyContent: 'flex-end' }}>
        <Row gutter={[16, 16]} style={{ justifyContent: 'flex-end' }}> 
          <Card
            style={{
              width: 500,
              height: 300,
              marginTop: 20,
              overflow: 'auto',
              borderRadius: 15, 
            }}
          >
            {selectedsData1 && selectedsData1.map(({ key, value_filter }) => (
              <Tag
                key={key}
                className="TagsSelectFilters"
                closable
                onClose={e => {
                  const updatedSelecteds = selectedsData1.filter(item => item.key !== key);
                  setSelectedsData1(updatedSelecteds);
                  setGenero(updatedSelecteds); 
                  setBanderaTags1(true);
                }}
              >
                {value_filter}
              </Tag>
            ))}
            {selectedsData2 && selectedsData2.map(({ key, value_filter }) => (
              <Tag
                key={key}
                className="TagsSelectFilters"
                closable
                onClose={e => {
                  const updatedSelecteds = selectedsData2.filter(item => item.key !== key);
                  setSelectedsData2(updatedSelecteds);
                  setPlanCost(updatedSelecteds); 
                  setBanderaTags2(true);
                }}
              >
              {value_filter}
              </Tag>
            ))}
            {selectedsData3 && selectedsData3.map(({ key, value_filter }) => (
              <Tag
                key={key}
                className="TagsSelectFilters"
                closable
                onClose={e => {
                  const updatedSelecteds = selectedsData3.filter(item => item.key !== key);
                  setSelectedsData3(updatedSelecteds);
                  setEdad(updatedSelecteds); 
                  setBanderaTags3(true);
                }}
              >
                {value_filter}
              </Tag>
            ))}
          </Card>
        </Row>
      </Col>
    </Row>
  );
};

export default Demograficos;